import session from '@/shared/session'

const initialState = () => ({
	patient: {
		forms: [],
	}
})

const state = initialState()

// getters
const getters = {
	getPatientForms: (state) => () => {
		return state.patient.forms
	},
}

// actions
const actions = {
	resetState({ commit }) {
		commit('reset_state')
	},

	async getFormsForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "patient-forms", { root: true })

		const forms = await session
			.get(`/api/patients/${rootState.patients.current.id}/forms/`)

		commit("set_forms", forms.data)

		dispatch("loading/end", "patient-forms", { root: true })

		return state.patient.forms
	},

	async filterAllForms({ dispatch }, params) {
		dispatch("loading/load", "patient-forms", { root: true })
		try {
			const forms = await session.get(`/api/patients/forms/`, { params })
			return forms.data
		} finally {
			dispatch("loading/end", "patient-forms", { root: true })
		}
	},

	savePatientForm({ dispatch, rootState }, data) {
		dispatch("loading/load", "patient-forms", { root: true })
		return session
			.post(`/api/patients/forms/`, { ...data, patient: rootState.patients?.current?.id })
			.then(form => {
				dispatch("getFormsForCurrentPatient")
				return form.data
			})
			.finally(() => {
				dispatch("loading/end", "patient-forms", { root: true })
			})
	},

	deletePatientForm({ dispatch }, id) {
		dispatch("loading/load", "patient-forms", { root: true })
		return session
			.delete(`/api/patients/forms/${id}/`)
			.then(() => {
				return dispatch("getFormsForCurrentPatient")
			})
			.finally(() => {
				dispatch("loading/end", "patient-forms", { root: true })
			})
	},
}

// mutations
const mutations = {
	reset_state(state) {
		Object.assign(state, initialState())
	},
	set_forms(state, forms) {
		state.patient.forms = forms
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
